var module = angular.module('octopusApp.master');

module.factory('gettingStartedStatusFactory', function ($timeout, $q, $rootScope, octopusRepository, octopusPermissionSet) {
    var GettingStartedStatus = function ($timeout, $rootScope, octopusRepository, octopusPermissionSet) {
        this.tasks = {};
        this.next = '';
        this.projects = [];
        this.releases = [];

        var subscribers = 0;

        function refresh(that) {
            var onboardingLoader = octopusRepository.UserOnboarding.get().then(function (userOnboardingData) {
                var next = '';

                for (var i = 0; i < userOnboardingData.Tasks.length; i++) {
                    var task = userOnboardingData.Tasks[i];

                    that.tasks[task.Category] = that.tasks[task.Category] || {};
                    that.tasks[task.Category][task.Name] = that.tasks[task.Category][task.Name] || {};
                    that.tasks[task.Category][task.Name].IsComplete = task.IsComplete;
                    that.tasks[task.Category][task.Name].IsEnabled = task.IsEnabled;
                }

                that.tasks.Infrastructure.IsEnabled = that.tasks.Infrastructure.CreatedEnvironment.IsEnabled;
                that.tasks.Infrastructure.Percent = 0;
                that.tasks.Infrastructure.IsComplete = false;

                if (that.tasks.Infrastructure.CreatedEnvironment.IsComplete) {
                    that.tasks.Infrastructure.Percent += 50;
                } else if (!!!next) {
                    next = "Infrastructure.CreatedEnvironment";
                }
                if (that.tasks.Infrastructure.CreatedMachine.IsComplete) {
                    that.tasks.Infrastructure.Percent += 50;
                } else if (that.tasks.Infrastructure.AddedAzureAccount.IsComplete) {
                    that.tasks.Infrastructure.Percent += 50;
                }
                else if (!!!next) {
                    next = "Infrastructure.CreatedMachineOrAccount";
                }
                if (that.tasks.Infrastructure.Percent === 100) {
                    that.tasks.Infrastructure.IsComplete = true;
                }

                that.tasks.Package.IsEnabled = that.tasks.Package.UploadedPackage.IsEnabled;
                that.tasks.Package.Percent = 0;
                that.tasks.Package.IsComplete = false;

                if (that.tasks.Package.UploadedPackage.IsComplete) {
                    that.tasks.Package.Percent += 100;
                } else if (that.tasks.Package.AddedFeed.IsComplete) {
                    that.tasks.Package.Percent += 100;
                } else if (!!!next) {
                    if (that.tasks.Deploy.CreatedRelease.IsEnabled && !that.tasks.Deploy.CreatedRelease.IsComplete) {
                        next = "Deploy.CreatedRelease";
                    }
                    else if (that.tasks.Deploy.DeployedRelease.IsEnabled && !that.tasks.Deploy.DeployedRelease.IsComplete) {
                        next = "Deploy.DeployedRelease";
                    }
                    else {
                        next = "Package";
                    }
                }
                if (that.tasks.Package.Percent === 100) {
                    that.tasks.Package.IsComplete = true;
                }

                that.tasks.Project.IsEnabled = that.tasks.Project.CreatedProject.IsEnabled;
                that.tasks.Project.Percent = 0;
                that.tasks.Project.IsComplete = false;

                if (that.tasks.Project.CreatedProject.IsComplete) {
                    that.tasks.Project.Percent += 50;
                } else if (!!!next) {
                    next = "Project.CreatedProject";
                }
                if (that.tasks.Project.AddedProjectStep.IsComplete) {
                    that.tasks.Project.Percent += 50;
                } else if (!!!next) {
                    next = "Project.AddedProjectStep";
                }
                if (that.tasks.Project.Percent === 100) {
                    that.tasks.Project.IsComplete = true;
                }

                that.tasks.Deploy.IsEnabled = that.tasks.Deploy.CreatedRelease.IsEnabled;
                that.tasks.Deploy.Percent = 0;
                that.tasks.Deploy.IsComplete = false;

                if (that.tasks.Deploy.CreatedRelease.IsComplete) {
                    that.tasks.Deploy.Percent += 50;
                } else if (!!!next) {
                    next = "Deploy.CreatedRelease";
                }
                if (that.tasks.Deploy.DeployedRelease.IsComplete) {
                    that.tasks.Deploy.Percent += 50;
                } else if (!!!next) {
                    next = "Deploy.DeployedRelease";
                }
                if (that.tasks.Deploy.Percent === 100) {
                    that.tasks.Deploy.IsComplete = true;
                }

                that.next = next;
            }).then(function () {

                var projectsLoader = octopusPermissionSet.isAuthorized({ permission: 'ProjectView', projectId: '*' }).then(function (result) {
                    if (result) {
                        return octopusRepository.Projects.list().then(function (projectsData) {
                            that.projects = projectsData.Items.slice(0, 5);
                        }).catch(function (errorCallback) {
                            if (errorCallback.StatusCode !== 403) {
                                return $q.reject(errorCallback);
                            }
                            that.projects = [];
                        });
                    } else {
                        that.projects = [];
                    }
                });

                var releasesLoader = octopusPermissionSet.isAuthorized({ permission: 'ReleaseView', projectId: '*' }).then(function (result) {
                    if (result) {
                        octopusRepository.Releases.list().then(function (releasesData) {
                            that.releases = releasesData.Items.slice(0, 5);
                        }).catch(function (errorCallback) {
                            if (errorCallback.StatusCode !== 403) {
                                return $q.reject(errorCallback);
                            }
                            that.releases = [];
                        });
                    } else {
                        that.releases = [];
                    }
                });

                return $q.all([projectsLoader, releasesLoader]);
            }).then(function () {
                $rootScope.$emit('getting-started-status:changed', that);
            }).then(function () {
                if (subscribers > 0 && !that.tasks.Deploy.DeployedRelease.IsComplete) {
                    $timeout(function () {
                        refresh(that);
                    }, 2000);
                }
            });

            return onboardingLoader;
        }

        this.init = function () {
            return refresh(this);
        };

        this.subscribe = function () {
            if (++subscribers === 1) {
                refresh(this);
            }
        };

        this.unsubscribe = function () {
            subscribers--;
        };
    };

    var status = new GettingStartedStatus($timeout, $rootScope, octopusRepository, octopusPermissionSet);

    return {
        subscribe: function (scope, callback) {
            status.subscribe();

            var handler = $rootScope.$on('getting-started-status:changed', function (_, data) { callback(data); });
            scope.$on('$destroy', function () {
                status.unsubscribe();
                handler();
            });
        },
        promise: $q(function (resolve) {
            status.init().then(function () {
                resolve(status);
            });
        })
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/master/getting-started/services/getting_started_status_factory.js
// module id = 2631964014818531
// module chunks = 1